export enum TextTrackType {
    SUBTITLES = 'subtitles', 
    CAPTIONS = 'captions', 
    METADATA = 'metadata', 
    DESCRIPTIONS = 'descriptions', 
    CHAPTERS = 'chapters' 
}